<template>
  <div>
    <section-collapseable
      title="Buying Offers"
      :sub-title="buyingOffers.length.toString()"
      button-text="Buying Offer"
      @add="$refs.buyingOfferModal.open(defaultEmptyBuyingOffer)"
      :collapseable="!!buyingOffers.length"
      :hide-initial-always="!buyingOffers.length"
      hide-initial-when-expanded
      :is-loading="isLoading"
    >
      <!-- Collapsed Section -->
      <template v-if="latestOffer">
        <info-heading
          heading="Latest Offer"
          :span="latestOfferStatus"
        ></info-heading>

        <buying-offer-item
          v-if="latestOffer"
          class="mt-50"
          :offer="latestOffer"
          @edit="openBuyingOfferModal"
        ></buying-offer-item>
      </template>

      <!-- Expanded Section -->
      <template v-slot:expanded>
        <form-field-select
          label="Offer Status"
          v-model="buyingInfo.buying_info_status"
          @change="updateBuyingInfoStatus"
          :loading="statusIsSaving"
          :disabled="statusIsSaving"
        >
          <option
            v-for="option in ENUMS.BuyingInfoStatusEnum"
            :value="option.value"
          >{{ option.label }}</option>
        </form-field-select>

        <hr>

        <!-- Latest Offers -->
        <buying-offer-item
          v-if="latestOffer"
          :offer="latestOffer"
          @edit="openBuyingOfferModal"
        ></buying-offer-item>

        <hr>

        <!-- Other Offers -->
        <template v-if="otherOffers">
          <buying-offer-item
            v-for="offer in otherOffers"
            :key="offer.id"
            :offer="offer"
            @edit="openBuyingOfferModal"
          ></buying-offer-item>
        </template>
      </template>
    </section-collapseable>

    <!-- Buying Offer Modal -->
    <modal-container>
      <modal-crud-form
        ref="buyingOfferModal"
        title="Buying Offer"
        form-component="buying-offer-form"
        is-double-column
      ></modal-crud-form>

      <modal-crud-form
        ref="buyingInfoModal"
        title="Buying Info Dates"
        form-component="buying-info-form"
        hide-delete-button
        is-triple-column
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import BuyingInfoFlipAnalysis from "../components/BuyingInfoFlipAnalysis";
import BuyingInfoWholesaleAnalysis from "../components/BuyingInfoWholesaleAnalysis";
import InfoHeading from "../components/InfoHeading";
import InfoItem from "../components/InfoItem";
import ProfitItem from "../components/ProfitItem";
import BuyingOfferItem from "../components/BuyingOfferItem";

export default {
  name: "LeadBuyingOffer",
  components: {
    BuyingOfferItem,
    ProfitItem,
    BuyingInfoWholesaleAnalysis,
    BuyingInfoFlipAnalysis,
    InfoHeading,
    InfoItem,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showOtherOffers: false,
      statusIsSaving: false,
      typeIsLoading: false,
      emptyWholesaleAnalysis: {
        after_repair_value: null,
        desired_wholesale_fee: null,
        offer_percentage: null,
        other_costs: null,
        repair_costs: null,
      },
      emptyFlipAnalysis: {
        after_repair_value: null,
        repair_costs: null,
        holding_costs: null,
        holding_time: null,
        other_costs: null,
        desired_profit: null,
      }
    }
  },
  computed: {
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord.record : {
        id: null,
        buying_info_status: null,
        buying_analysis_id: null,
        buying_analysis_type: null,
        buying_info_accepted_at: null,
        buying_info_closing_at: null,
        buying_info_contracted_at: null,
      };
    },
    buyingInfo() {
      return {
        id: this.record.id,
        record_id: this.record.id,
        buying_info_status: this.record.buying_info_status,

        buying_analysis_id: this.record.buying_analysis_id,

        buying_info_accepted_at: this.record.buying_info_accepted_at,
        buying_info_closing_at: this.record.buying_info_closing_at,
        buying_info_contracted_at: this.record.buying_info_contracted_at,
      }
    },
    infoStatus() {
      return this.$store.state.activeRecord ? this.$store.state.activeRecord.record.buying_info_status : null;
    },
    buyingOffers() {
      if(!this.$store.state.activeRecord) return [];

      let offers = this.$utils.clone(this.$store.state.activeRecord.buyingOffers);
      offers.sort((a,b) => new Date(b.created_at) - new Date(a.created_at));
      return offers.sort((a,b) => new Date(b.date) - new Date(a.date));
    },
    latestOffer() {
      return this.buyingOffers[0];
    },
    latestOfferStatus() {
      if(this.latestOffer) {
        return this.$utils.newGetEnumLabel(this.infoStatus, ENUMS.BuyingInfoStatusEnum);
      } else {
        return null;
      }
    },
    otherOffers() {
      const otherOffers = this.$utils.clone(this.buyingOffers);
      otherOffers.shift();

      return otherOffers;
    },
    defaultEmptyBuyingOffer() {
      return {
        record_id: this.record.id
      }
    },
  },
  methods: {
    updateBuyingInfoStatus() {
      this.statusIsSaving = true;

      this.$api.records.updateBuyingInfoStatus(this.buyingInfo).then(() => {
        this.statusIsSaving = false;
        this.$buefy.toast.open({message: "Updated Offer Status", type: 'is-success'});
      });
    },
    openBuyingOfferModal(buyingOffer) {
      this.$refs.buyingOfferModal.open(buyingOffer)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

hr {
  margin: 0.75rem (-$modalGutter);
}
</style>
